import moment from '../../moment-hawaii';

const ticketAvailabilityInfo = (ticket, startTime) => {
    const momentStart = moment(startTime);
    const notYetValid = !!ticket.date_from && moment(ticket.date_from).isAfter(momentStart);
    const expired =
        !!ticket.date_to &&
        moment(ticket.date_to)
            .endOf('day')
            .isBefore(momentStart);

    return { available: !(notYetValid || expired), notYetValid, expired };
};

export default ticketAvailabilityInfo;
